// removed by extract-text-webpack-plugin
module.exports = {"word":"SplitText_word_1TpoW"};